import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {FlexSectionSchema} from './flexSection'

export const SegmentedControlPanelItemSchema = buildEntrySchemaFor('segmentedControlPanelItem', {
  fields: z.lazy(() =>
    z.object({
      label: z.string(),
      flexSections: z.array(z.lazy(() => FlexSectionSchema)),
    }),
  ),
})

export type SegmentedControlPanelItem = z.infer<typeof SegmentedControlPanelItemSchema>

export const SegmentedControlPanelSchema = buildEntrySchemaFor('segmentedControlPanel', {
  fields: z.lazy(() =>
    z.object({
      ariaLabel: z.string().optional(),
      panelItems: z.array(SegmentedControlPanelItemSchema),
    }),
  ),
})

export type SegmentedControlPanel = z.infer<typeof SegmentedControlPanelSchema>
